import React from "react";
import "chartjs-adapter-date-fns";
import { DashboardProvider } from "../../context/dashboard_provider";
import { Grid } from "@mui/material";
import { CollapsableCard } from "../general/collapsable_card";
import { ChartCard, ChartDivider } from "../metering_tab/chart_card";
import { FlexChart } from "../metering_tab/flex_chart";
import { GridChart } from "../metering_tab/grid_chart";
import { ImbalancePriceEpexChart } from "../metering_tab/imbalance_price_epex_chart";
import { InternalChart } from "../metering_tab/internal_chart";
import { LynxChart } from "../metering_tab/lynx_chart";
import { ProductionChart } from "../metering_tab/production_chart";
import { SOCChart } from "../metering_tab/soc_chart";

export default function CommissioningMetering({
  metering,
  actuals,
  fetchingMetering,
  fetchingActuals,
  prices,
  fetchingPrices,
  sx,
  startCollapsed = false,
}) {
  let cardTitle = "Control phase metering";
  return (
    <DashboardProvider>
      <CollapsableCard startCollapsed={startCollapsed} title={cardTitle} {...sx}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} sm={12}>
            <ChartDivider
              Chart={<GridChart metering={metering} />}
              title="Grid"
              data={metering}
              isLoading={fetchingMetering}
              useDivider={true}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <ChartDivider
              Chart={<InternalChart metering={metering} />}
              title="Internal"
              data={metering}
              isLoading={fetchingMetering}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <ChartDivider
              Chart={<FlexChart metering={metering} />}
              title="Flex"
              data={metering}
              isLoading={fetchingMetering}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <ChartDivider
              Chart={<ProductionChart metering={metering} />}
              title="Production"
              data={metering}
              isLoading={fetchingMetering}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <ChartDivider
              Chart={<SOCChart metering={metering} />}
              title="SOC"
              data={metering}
              isLoading={fetchingMetering}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <ChartCard
              Chart={<ImbalancePriceEpexChart prices={prices} />}
              title="Imbalance and Epex Prices"
              data={prices}
              isLoading={fetchingPrices}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <ChartDivider
              Chart={<LynxChart metering={actuals} />}
              title="Control phase network operator metering"
              data={actuals}
              isLoading={fetchingActuals}
            />
          </Grid>
        </Grid>
      </CollapsableCard>
    </DashboardProvider>
  );
}
